export interface CategoryOption {
  id: string
  label: string
  icon: string
  group: string
}

export const CATEGORY_GROUPS = [
  'Popular',
  'Knowledge',
  'Culture & Media',
  'World & Nature',
  'Lifestyle'
] as const

export type CategoryGroup = typeof CATEGORY_GROUPS[number]

export const INTEREST_OPTIONS: CategoryOption[] = [
  // ── Popular ──
  { id: 'business', label: 'Business & Money', icon: 'TrendingUp', group: 'Popular' },
  { id: 'football', label: 'Football', icon: 'Circle', group: 'Popular' },
  { id: 'sports', label: 'Other Sports', icon: 'Trophy', group: 'Popular' },
  { id: 'fitness', label: 'Fitness & Health', icon: 'Dumbbell', group: 'Popular' },
  { id: 'celebrities', label: 'Celebrities', icon: 'Star', group: 'Popular' },
  { id: 'entertainment', label: 'Entertainment', icon: 'Clapperboard', group: 'Popular' },
  { id: 'internet', label: 'Internet Culture', icon: 'Wifi', group: 'Popular' },
  { id: 'drama', label: 'Drama & True Crime', icon: 'Search', group: 'Popular' },

  // ── Knowledge ──
  { id: 'tech', label: 'Tech & Gadgets', icon: 'Smartphone', group: 'Knowledge' },
  { id: 'ai_future', label: 'AI & Future Tech', icon: 'Bot', group: 'Knowledge' },
  { id: 'science', label: 'Science', icon: 'FlaskConical', group: 'Knowledge' },
  { id: 'history', label: 'History', icon: 'Landmark', group: 'Knowledge' },
  { id: 'theories', label: 'Theories & Philosophy', icon: 'Lightbulb', group: 'Knowledge' },
  { id: 'psychology', label: 'Psychology', icon: 'Brain', group: 'Knowledge' },
  { id: 'career', label: 'Career & Education', icon: 'GraduationCap', group: 'Knowledge' },

  // ── Culture & Media ──
  { id: 'music', label: 'Music', icon: 'Music', group: 'Culture & Media' },
  { id: 'movies_tv', label: 'Movies & TV', icon: 'Film', group: 'Culture & Media' },
  { id: 'gaming', label: 'Gaming', icon: 'Gamepad2', group: 'Culture & Media' },
  { id: 'art', label: 'Art', icon: 'Palette', group: 'Culture & Media' },
  { id: 'lifestyle', label: 'Lifestyle & Fashion', icon: 'Shirt', group: 'Culture & Media' },
  { id: 'mental_health', label: 'Mental Health', icon: 'Heart', group: 'Culture & Media' },

  // ── World & Nature ──
  { id: 'travel', label: 'Travel & Places', icon: 'Plane', group: 'World & Nature' },
  { id: 'climate', label: 'Climate', icon: 'Globe', group: 'World & Nature' },
  { id: 'space', label: 'Space', icon: 'Rocket', group: 'World & Nature' },
  { id: 'geography', label: 'Geography', icon: 'Mountain', group: 'World & Nature' },
  { id: 'animals', label: 'Animals', icon: 'PawPrint', group: 'World & Nature' },
  { id: 'ocean', label: 'Ocean', icon: 'Waves', group: 'World & Nature' },

  // ── Lifestyle ──
  { id: 'food', label: 'Food', icon: 'UtensilsCrossed', group: 'Lifestyle' },
  { id: 'medicine', label: 'Medicine', icon: 'Stethoscope', group: 'Lifestyle' },
  { id: 'mythology', label: 'Mythology', icon: 'Flame', group: 'Lifestyle' },
  { id: 'cars', label: 'Cars', icon: 'Car', group: 'Lifestyle' },
  { id: 'military', label: 'Military', icon: 'Shield', group: 'Lifestyle' },
]

export const getCategoriesByGroup = (): Record<string, CategoryOption[]> => {
  const grouped: Record<string, CategoryOption[]> = {}
  for (const group of CATEGORY_GROUPS) {
    grouped[group] = INTEREST_OPTIONS.filter(o => o.group === group)
  }
  return grouped
}
